<style></style>
<i18n>
  {
  "ru": {
  "addItem": "Добавить тип обуви",
  "name": "Название",
  "position": "Позиция",
  "create": "Создать",
  "close": "Закрыть",
  "status": {
    "default" : "Выберите статус",
    "active" : "Активный",
    "disable": "Выключена"
  }
  },
  "uk": {
  "addItem": "Додати тип взуття",
  "name": "Назва",
  "position": "Позиція",
  "create": "Створити",
  "close": "Закрити",
  "status": {
    "default" : "Виберіть статус",
    "active" : "Активний",
    "disable": "Вимкнений"
  }
  }
  }
</i18n>
<template>
  <div>
    <div class="row">
      <div class="col-md-12 change-lang">
        <router-link class="locale" :to="{ params: { locale: 'ru' } }">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAGFBMVEVHcEz/PgDf4eGqsdKASnn/PQDg4eI/UbUIMKX5AAAABXRSTlMAgIDAwJ6ZvvQAAAA3SURBVBjTY2AgAzApwYECA1saHCQQy2E2hgMDBvZyOCgglsPiAgcODKyhcBBALIdREA4EyAkCAFaFO+fKN2UpAAAAAElFTkSuQmCC"
          />
          Русский</router-link
        >
        <router-link class="locale" :to="{ params: { locale: 'uk' } }"
          ><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAD1BMVEVHcEz91zYilfMhlvP92DVw3Q5rAAAAA3RSTlMAgIAsTd+1AAAAJklEQVQY02NgIAMwKcGBAgOzMRwYUJnD4gIHDlTmMArCgQA5QQAAdeEl/Xx287cAAAAASUVORK5CYII="
          />
          Украинский</router-link
        >
      </div>
    </div>
    <div class="btn-block-top row">
      <div class="col-md-3"></div>
      <div class="col-md-9">
        <button class="btn btn-primary" @click.prevent="showAdd = !showAdd">
          {{ $t("addItem") }}
        </button>
      </div>
    </div>
    <div class="create-block" v-if="showAdd">
      <b-card>
        <form @submit.prevent="addType">
          <div class="row">
            <div class="form-group col-8">
              <label>{{ $t("name") }}:</label>
              <input
                type="text"
                required
                class="form-control"
                v-model="form.name[locale]"
              />
            </div>
            <div class="form-group col-4">
              <label>{{ $t("position") }}:</label>
              <input
                type="number"
                required
                class="form-control"
                v-model="form.position"
              />
            </div>
          </div>
          <div class="btn-actions">
            <button type="submit" class="btn btn-primary btn-sm">
              {{ $t("create") }}
            </button>
            <button
              type="button"
              class="btn btn-link btn-sm"
              @click.prevent="showAdd = !showAdd"
            >
              {{ $t("close") }}
            </button>
          </div>
        </form>
      </b-card>
    </div>
    <div class="as-datatable">
      <b-table
        v-if="$store.state.GlobalData.type_shoes"
        bordered
        striped
        hover
        small
        :busy="!isBusy"
        :items="$store.state.GlobalData.type_shoes"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template v-slot:cell(name)="row">
          {{ row.item.name[locale] }}
        </template>
        <template v-slot:cell(actions)="row">
          <div class="btn-actions">
            <button @click="toggleEdit(row)" class="btn btn-primary btn-sm">
              <font-awesome-icon
                v-if="!row.detailsShowing"
                class="as-icon"
                :icon="['fas', 'pencil-alt']"
              />
              <font-awesome-icon
                v-else
                class="as-icon"
                :icon="['far', 'eye-slash']"
              />
            </button>

            <button
              class="btn btn-danger btn-sm"
              @click.prevent="removeEl(row)"
            >
              <font-awesome-icon class="as-icon" :icon="['fas', 'trash-alt']" />
            </button>
          </div>
        </template>
        <template v-slot:row-details="row">
          <b-card>
            <form action="#" method="POST" @submit.prevent="savePost(row)">
              <div class="row">
                <div class="form-group col-8">
                  <label>{{ $t("name") }}:</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="row.item.name[locale]"
                  />
                </div>
                <div class="form-group col-4">
                  <label>{{ $t("position") }}:</label>
                  <input
                    type="number"
                    required
                    class="form-control"
                    v-model="row.item.position"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Статус:</label>
                <select
                  class="form-control"
                  name="status"
                  v-model="row.item.status"
                >
                  <option value="default">{{ $t("status.default") }}</option>
                  <option value="1" :selected="row.item.status === 1">{{
                    $t("status.active")
                  }}</option>
                  <option value="2" :selected="row.item.status === 2">{{
                    $t("status.disable")
                  }}</option>
                </select>
              </div>
              <div class="actions-btn">
                <button
                  class="btn btn-primary btn-sm"
                  type="submit"
                  :disabled="row.item.ready"
                >
                  {{ $t("create") }}
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  @click.prevent="row.toggleDetails"
                >
                  {{ $t("close") }}
                </button>
              </div>
            </form>
          </b-card>
        </template>
      </b-table>
      <b-row v-if="$store.state.GlobalData.type_shoes">
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="$store.state.GlobalData.type_shoes.length"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
      <p class="text-danger text-center" v-else>Типы обуви отсутствуют...</p>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  data() {
    return {
      locale: this.$route.params.locale,
      myFiles: [],
      changeCat: "0",
      filter: "0",
      currentPage: 1,
      perPage: 5,
      isBusy: true,
      showAdd: false,
      form: {
        name: {
          ru: null,
          uk: null
        }
      },
      fields: [
        {
          key: "index",
          label: "№",
          sortable: true
        },
        {
          key: "name",
          label: "Название",
          sortable: false
        },
        {
          key: "position",
          label: "Позиция",
          sortable: true
        },
        {
          key: "status",
          label: "Статус",
          sortable: true
        },
        {
          key: "actions",
          label: "Действия",
          sortable: false
        }
      ]
    };
  },
  methods: {
    toggleEdit(row) {
      row.toggleDetails(true);
    },
    addType() {
      this.form.status = 1;
      let _this = this;
      let store = this.$store.state.GlobalData.type_shoes;
      Axios.post("/.netlify/functions/type-shoes-create", this.form)
        .then(function(res) {
          _this.form.index = store ? store.length + 1 : 0;
          _this.form.id = res.data.ref["@ref"].id;
          store.push(_this.form);
          _this.showAdd = false;
          _this.form = clearForm();
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    savePost(el) {
      el.item.ready = true;
      let form = {
        id: el.item.id,
        name: el.item.name,
        position: el.item.position,
        status: el.item.status
      };
      Axios.post("/.netlify/functions/type-shoes-update", form)
        .then(function() {
          el.toggleDetails(false);
          el.item.ready = false;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    removeEl(el) {
      if (confirm("Вы уверены?")) {
        let _this = this;
        Axios.post("/.netlify/functions/type-shoes-delete", { id: el.item.id })
          .then(function() {
            _this.$store.state.GlobalData.type_shoes.splice(
              el.item.index - 1,
              1
            );
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        return null;
      }
    }
  },
  components: {},
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  }
};
function clearForm() {
  let form = {
    name: {
      ru: null,
      uk: null
    },
    position: 0
  };
  return form;
}
</script>
